import { observable } from 'mobx';
import { getNeteaseHotSongList, getNeteaseSearchSongList, getNeteaseSongMassge } from './datasrc/Netease';
import { getKugouNewSongList, getKugouSearchSongList, getKugouSongMassge } from './datasrc/Kugou';


class DataPageStore {

  @observable _dataSource = 1;
 
  @observable _audio = null;

  @observable _searchSongList = [];

  @observable _playSongList = this.getLocalStore() || [];

  @observable _count = 0;

  @observable _isPlay = false;

  @observable _volume = 0.6;

  @observable _silent = false;

  @observable _disabled = false;

  @observable _showPlayList = false;

  @observable _currentTime = 0;

  @observable _loop = false;

  @observable _errMassge = '';

  @observable _keyword = '';

  @observable _page = 0;

  @observable _pageSize = 10;

  @observable _lastPage = false;

  @observable _listType = 0;

  @observable _windowWidth = 900;

  @observable _windowHeight = 680;

  get dataSource() {
    return this._dataSource;
  }

  set dataSource(value) {
    this._dataSource = value;
  }

  get audio() {
    return this._audio;
  }

  set audio(value) {
    this._audio = value;
  }

  get searchSongList() {
    return this._searchSongList;
  }

  set searchSongList(value) {
    if(!value) value = [];
    this._searchSongList = value;
  }

  get playSongList() {
    return this._playSongList;
  }

  set playSongList(value) {
    this._playSongList = value;
    if(this._playSongList.length === 1) {
      this.loop = true;
    }else{
      this.loop = false;
    }
    this.setLocalStore(this._playSongList);
  }

  get count() {
    return this._count;
  }

  set count(value) {
    if(this.playSongList.length === 0) {
      this._count = 0;
      return;
    }
    if(value < 0) {
      this._count = this.playSongList.length - 1;
      return;
    }
    if(value > this.playSongList.length - 1) {
      this._count = 0;
      return;
    }
    this._count = value;
  }

  get isPlay() {
    return this._isPlay;
  }

  set isPlay(value) {
    this._isPlay = value;
    if(this._audio) {
      if(this._isPlay) this._audio.play();
      else  this._audio.pause();
    }
  }

  get volume() {
    return this._volume;
  }

  set volume(value) {
    this._volume = value;
    if(this._audio) this._audio.volume = this._volume;
  }

  get silent() {
    return this._silent;
  }

  set silent(value) {
    this._silent = value;
    if(this._silent) {
      this.volume = 0;
    }else{
      this.volume = 0.6;
    }
  }

  get disabled() {
    return this._disabled;
  }

  set disabled(value) {
    this._disabled = value;
  }

  get showPlayList() {
    return this._showPlayList;
  }

  set showPlayList(value) {
    this._showPlayList = value;
  }

  get currentTime() {
    return this._currentTime;
  }

  set currentTime(value) {
    this._currentTime = value;
    //if(this._audio) this._audio.currentTime = this._currentTime;
  }

  get loop() {
    return this._loop;
  }

  set loop(value) {
    this._loop = value;
  }

  get errMassge() {
    return this._errMassge;
  }

  set errMassge(value) {
    if(typeof(value) === 'string') {
      this._errMassge = value;
    }
    if(typeof(value) === 'object') {
      this._errMassge = value.message;
    }
  }

  get keyword() {
    return this._keyword;
  }

  set keyword(value) {
    this._keyword = value;
  }

  get page() {
    return this._page;
  }

  set page(value) {
    this._page = value;
  }

  get pageSize() {
    return this._pageSize;
  }

  get lastPage() {
    return this._lastPage;
  }

  set lastPage(value) {
    this._lastPage = value;
  }

  get listType() {
    return this._listType;
  }

  set listType(value) {
    this._listType = value;
  }

  get windowWidth() {
    return this._windowWidth;
  }

  set windowWidth(value) {
    if(value < 800) value = 800;
    this._windowWidth = value;
  }

  get windowHeight() {
    return this._windowHeight;
  }

  set windowHeight(value) {
    if(value < 680) value = 680;
    this._windowHeight = value;
  }

  get scrollHeight() {
    return this.windowHeight - 200;
  }

  setLocalStore(data) {
    let storage = localStorage || window.localStorage;
    if(storage) {
      storage.setItem('playList', JSON.stringify(data));
      //console.log(storage.getItem('playList'));
    }
  }

  getLocalStore() {
    let data = null;
    let storage = localStorage || window.localStorage;
    if(storage) {
      data = JSON.parse(storage.getItem('playList'));
    }
    return data;
  }

  addPlaySongList(value) {
    let tempList = this.playSongList;
    tempList.push(value);
    this.playSongList = tempList;

    if(this.playSongList.length === 1) {
      this.loop = true;
    }else{
      this.loop = false;
    }
  }

  get coutSongMassge() {
    if(this.playSongList.length > 0) {
      return this.playSongList[this._count];
    }else{
      return {
        SongName: '未知歌曲',
        PlayUrl: '',
        SingerName: '未知艺术家',
        AlbumName: '未知专辑',
        Img: require('./assets/bg.png'),
        Lyrics: [],
        Duration: 0,
        Hash: ''
      };
    }
  }

  searchSongListStore() {
    switch (this.dataSource) {
      case 1:
        getNeteaseSearchSongList(this.keyword, this.page, this.pageSize)
        .then(data => {
          this.listType = 0;
          this.lastPage = data.list.length < this.pageSize ? true : false;
          if(data.page > 1) {
            this.searchSongList = this.searchSongList.concat(data.list);
          }else{
            this.searchSongList = data.list;
          }
        }).catch((err) => {
          this.errMassge = err;
        });
        break;
    
      case 2:
        getKugouSearchSongList(this.keyword, this.page, this.pageSize)
        .then(data => {
          this.listType = 0;
          this.lastPage = data.list.length < this.pageSize ? true : false;
          if(data.page > 1) {
            this.searchSongList = this.searchSongList.concat(data.list);
          }else{
            this.searchSongList = data.list;
          }
        }).catch((err) => {
          this.errMassge = err;
        });
        break;
      
      default:
        break;
    }
  }

  newSongListStore() {
    switch (this.dataSource) {
      case 1:
        getNeteaseHotSongList()
        .then(list => {
          this.listType = 1;
          this.searchSongList = list;
        }).catch((err) => {
          this.errMassge = err;
        });
        break;
    
      case 2:
        getKugouNewSongList()
        .then(list => {
          this.listType = 1;
          this.searchSongList = list;
        }).catch((err) => {
          this.errMassge = err;
        });
        break;
      
      default:
        break;
    }
    
  }

  addSongInList(hash,callback) {
    let songIndex = this.findInPlayList(hash);
    //console.log(songIndex,songData);
    if(songIndex >= 0) {
      let songData = this.playSongList[songIndex];
      if(callback) callback(songData,songIndex);
    }else{
      switch (this.dataSource) {
        case 1:
          getNeteaseSongMassge(hash)
          .then(songMassge => {
            this.addPlaySongList(songMassge);
            if(callback) callback(songMassge,this.playSongList.length - 1);
          }).catch((err) => {
            console.log(err);
            this.errMassge = err;
          });
          break;
      
        case 2:
          getKugouSongMassge(hash)
          .then(songMassge => {
            this.addPlaySongList(songMassge);
            if(callback) callback(songMassge,this.playSongList.length - 1);
          }).catch((err) => {
            this.errMassge = err;
          });
          break;
        
        default:
          break;
      }

    }
  }

  addSongAndPlay(hash) {
    this.addSongInList(hash,(songMassge,index)=>{
      this.count = index;
    })
  }

  findInPlayList(hash) {
    let tempList = this.playSongList;
    return tempList.findIndex((item, index, arr) => {
      return hash === item.Hash;
    })
  }

  removeInSongList(hash) {
    let curHash = this.coutSongMassge.Hash;
    let tempList = this.playSongList;
    this.playSongList = tempList.filter((item, index, arr) => {
      return hash !== item.Hash;
    });

    this.count = this.findInPlayList(curHash);
  }

  clearSongList() {
    this.playSongList = [];
    this.audio = null;
    this.count = 0;
    DataStore.isPlay = false;
  }

  createAudio(url) {
    //console.log(this.audio)
    if(this._audio && this._audio.parent) {
      document.getElementById('audio-box').removeChild(this._audio);
    }
    if(this._audio && this._audio.src === url) {
      return null;
    }
    if(url) {
      this.audio = new Audio();
      this.audio.style.display = 'none';
      this.audio.src = url;
      this.audio.volume = this.volume;
      this.audio.autoplay = true;
      document.getElementById('audio-box').appendChild(this.audio);
    }
  }
}

const DataStore = new DataPageStore();

// getSearchSongList('goog').then(function (result) {
//     console.log(result);
// });

export { DataStore }


// WEBPACK FOOTER //
// ./src/DataStore.js